export default "__VITE_ASSET__B7VhTg0B__"